<template>
  <div class="info-card-page-list">
    <Action-panel :isReady="isPageReady">
      <Button-base
        :type="2"
        :text="translations.labels.button_add_infoCard"
        :hoverInfo="translations.labels.button_add_infoCard_hover"
        :onClick="newItem"
      />
    </Action-panel>

    <TableList
      :is-ready="isPageReady"
      :headers="headers"
      :items="model.filter(l => true)"
      :items-per-page="-1"
      sortable
      hideFooter
      @sorted="saveOrder"
      item-key="id"
      :searchVisible="false"
       />
  </div>
</template>

<script>
import Component, { mixins } from "vue-class-component";
import Container from "@/components/dom/Container";
import ActionPanel from "@/components/panel/ActionPanel";
import InnerPanel from "@/components/panel/InnerPanel";
import TablePanel from "@/components/panel/TablePanel";
import ButtonBase from "@/components/dom/ButtonBase";
import SvgIcon from "@/components/dom/SvgIcon";
import Round from "@/components/dom/Round";
import TableList from "@/components/table/TableList";
import Translations from "@/mixins/translations";

@Component({
   components: {
    ActionPanel,
    InnerPanel,
    TablePanel,
    ButtonBase,
    SvgIcon,
    Round,
    Container,
    TableList
  },
  inject: {
    infoCardPageService: "infoCardPageService",
    toastService: "toastService"
  }
})
export default class InfoCardList extends mixins(Translations) {
  isPageReady = false;
  model = [];
  search = "";

  async init () {
    try {
      this.model = await this.infoCardPageService.listCards(this.$route.params.idInfoCardPage);
      this.isPageReady = true;
    } catch (error) {
      this.toastService.error(this.translations.errors.somethingWrong);
    }
  }

  toastSuccessLabel (isEnabled) {
    return isEnabled
      ? this.toastService.success(this.translations.success.infoCard_disable)
      : this.toastService.success(this.translations.success.infoCard_enable);
  }

  async toggleEnabled(idInfoCardPage, idInfoCard, isEnabled) {
    const status = isEnabled ? "disable" : "enable";
    this.isPageReady = false;

    try {
      await this.infoCardPageService.setCardEnabled(idInfoCardPage, idInfoCard, status);
      this.model = await this.infoCardPageService.listCards(this.$route.params.idInfoCardPage);

      this.toastSuccessLabel(isEnabled);
      this.isPageReady = true;
    } catch (error) {
      this.isPageReady = true;
      this.toastService.error(this.translations.errors.somethingWrong);
    }
  }

  newItem() {
    this.$router.push(`/info-card-pages/${this.$route.params.idInfoCardPage}/cards/new`);
  }

  get headers() {
    return [
      {
        text: this.translations.labels.infoCard_table_code,
        value: "code"
      },
      {
        text: this.translations.labels.table_order,
        value: "displayOrder"
      },
      {
        text: this.translations.labels.table_detail,
        value: "detail",
        type: "link",
        icon: "mdi-feature-search-outline",
        formatValue: (item) => {
          return `/info-card-pages/${this.$route.params.idInfoCardPage}/cards/detail/${item.id}`;
        },
      },
      {
        text: this.translations.labels.table_clone,
        value: "clone",
        type: "link",
        formatValue: (item) => {
          return `/info-card-pages/${this.$route.params.idInfoCardPage}/cards/clone/${item.id}`;
        },
        icon: "mdi-content-duplicate",
        buttonType: 2,
      },
      {
        text: this.translations.labels.table_edit,
        value: "edit",
        type: "link",
        formatValue: (item) => {
          return `/info-card-pages/${this.$route.params.idInfoCardPage}/cards/edit/${item.id}`;
        },
        icon: "mdi-pencil",
        buttonType: 2,
      },
      {
        text: this.translations.labels.table_enable,
        value: "enable",
        type: "switch",
        itemValue: (item) => {
          return item.isEnabled;
        },
        onAction: (item) => {
          this.toggleEnabled(this.$route.params.idInfoCardPage, item.id, item.isEnabled);
        },
      }
    ];
  }

  mounted () {
    this.init();
    this.$store.commit(
      "SET_SECTION_TITLE",
      this.translations.pageTitles.infoCards_list
    );
  }

  async saveOrder(event) {
    const movedItem = this.model.splice(event.oldIndex, 1);
    this.model.splice(event.newIndex, 0, movedItem[0]);

    let newOrders = [];
    this.model.forEach((m, i) => {
      const index = i + 1;
      this.model[i].priorityOrder = index;
      newOrders.push({
        id: m.id,
        displayOrder: index
      });
    });

    try {
      await this.infoCardPageService.saveCardsOrder(this.$route.params.idInfoCardPage, newOrders);
      this.model = await this.infoCardPageService.listCards(this.$route.params.idInfoCardPage);
    } catch (e) {
      this.toastService.error(this.translations.errors.somethingWrong);
    }
  }
}

</script>
<style lang="scss" scoped></style>
